var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticStyle: { width: "100%" } },
        [
          _c(
            "el-dropdown",
            { attrs: { trigger: "click" }, on: { mouseup: _vm.handleMouseUp } },
            [
              _vm._t("icon"),
              _vm.curComponent
                ? _c(
                    "el-dropdown-menu",
                    [
                      _vm.editFilter.includes(_vm.curComponent.type)
                        ? _c(
                            "el-dropdown-item",
                            {
                              attrs: { icon: "el-icon-edit-outline" },
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.edit($event)
                                },
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("panel.edit")) + "\n        "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm.curComponent.type != "custom-button"
                        ? _c(
                            "el-dropdown-item",
                            {
                              attrs: { icon: "el-icon-document-copy" },
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.copy($event)
                                },
                              },
                            },
                            [
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("panel.copy")) + " ("),
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.systemOS === "Mac",
                                        expression: "systemOS==='Mac'",
                                      },
                                    ],
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "icon iconfont icon-command",
                                    }),
                                    _vm._v("+ D"),
                                  ]
                                ),
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.systemOS !== "Mac",
                                        expression: "systemOS!=='Mac'",
                                      },
                                    ],
                                  },
                                  [_vm._v("Control + D")]
                                ),
                                _vm._v(")"),
                              ]),
                            ]
                          )
                        : _vm._e(),
                      _c(
                        "el-dropdown-item",
                        {
                          attrs: { icon: "el-icon-delete" },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.deleteComponent($event)
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("panel.delete")) + "\n        ")]
                      ),
                      _vm.curComponent.type === "de-tabs"
                        ? _c(
                            "el-dropdown-item",
                            {
                              attrs: { icon: "el-icon-sort" },
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.openCustomSort($event)
                                },
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("chart.sort")) + "\n        "
                              ),
                            ]
                          )
                        : _vm._e(),
                      !_vm.curComponent.auxiliaryMatrix
                        ? _c(
                            "el-dropdown-item",
                            [
                              _c(
                                "el-dropdown",
                                { attrs: { placement: "right-start" } },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "el-icon-copy-document" },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(_vm.$t("panel.level")) +
                                          " "
                                      ),
                                      _c("i", {
                                        staticClass:
                                          "el-icon-arrow-right el-icon--right",
                                      }),
                                    ]
                                  ),
                                  _c(
                                    "el-dropdown-menu",
                                    {
                                      attrs: { slot: "dropdown" },
                                      slot: "dropdown",
                                    },
                                    [
                                      _c(
                                        "el-dropdown-item",
                                        {
                                          attrs: { icon: "el-icon-upload2" },
                                          nativeOn: {
                                            click: function ($event) {
                                              return _vm.topComponent($event)
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("panel.topComponent")
                                            ) + "\n              "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "el-dropdown-item",
                                        {
                                          attrs: { icon: "el-icon-download" },
                                          nativeOn: {
                                            click: function ($event) {
                                              return _vm.bottomComponent($event)
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("panel.bottomComponent")
                                            ) + "\n              "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "el-dropdown-item",
                                        {
                                          attrs: { icon: "el-icon-arrow-up" },
                                          nativeOn: {
                                            click: function ($event) {
                                              return _vm.upComponent($event)
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("panel.upComponent")
                                            ) + "\n              "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "el-dropdown-item",
                                        {
                                          attrs: { icon: "el-icon-arrow-down" },
                                          nativeOn: {
                                            click: function ($event) {
                                              return _vm.downComponent($event)
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("panel.downComponent")
                                            ) + "\n              "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.linkageSettingShow
                        ? _c(
                            "el-dropdown-item",
                            {
                              attrs: { icon: "el-icon-link" },
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.linkageSetting($event)
                                },
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("panel.linkage_setting")) +
                                  "\n        "
                              ),
                            ]
                          )
                        : _vm._e(),
                      "de-tabs" === _vm.curComponent.type
                        ? _c(
                            "el-dropdown-item",
                            {
                              attrs: { icon: "el-icon-plus" },
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.addTab($event)
                                },
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("panel.add_tab")) + "\n        "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm.linkJumpSetShow
                        ? _c(
                            "el-dropdown-item",
                            {
                              attrs: { icon: "el-icon-connection" },
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.linkJumpSet($event)
                                },
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("panel.setting_jump")) +
                                  "\n        "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm.curComponent.type != "custom-button"
                        ? _c(
                            "el-dropdown-item",
                            {
                              attrs: { icon: "el-icon-magic-stick" },
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.boardSet($event)
                                },
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("panel.component_style")) +
                                  "\n        "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm.curComponent.type != "custom-button"
                        ? _c(
                            "el-dropdown-item",
                            {
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.hyperlinksSet($event)
                                },
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "icon iconfont icon-chaolianjie1",
                              }),
                              _vm._v(
                                _vm._s(_vm.$t("panel.hyperlinks")) +
                                  "\n        "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm.curComponent.type !== "view" &&
                      !_vm.curComponent.auxiliaryMatrix
                        ? _c(
                            "el-dropdown-item",
                            {
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.positionAdjust($event)
                                },
                              },
                            },
                            [
                              _c("i", { staticClass: "el-icon-map-location" }),
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.$t("panel.position_adjust")) +
                                  "\n        "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "dialog-css",
          attrs: {
            visible: _vm.hyperlinksSetVisible,
            width: "400px",
            "destroy-on-close": true,
            "append-to-body": true,
            "show-close": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.hyperlinksSetVisible = $event
            },
          },
        },
        [
          _vm.hyperlinksSetVisible
            ? _c("HyperlinksDialog", {
                attrs: { "link-info": _vm.curComponent.hyperlinks },
                on: {
                  onClose: function ($event) {
                    _vm.hyperlinksSetVisible = false
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm.showCustomSort
        ? _c(
            "el-dialog",
            {
              directives: [{ name: "dialogDrag", rawName: "v-dialogDrag" }],
              staticClass: "dialog-css",
              attrs: {
                title: _vm.$t("chart.custom_sort"),
                visible: _vm.showCustomSort,
                "show-close": false,
                width: "500px",
                "append-to-body": true,
              },
            },
            [
              _c("custom-tabs-sort", {
                ref: "customTabsSort",
                attrs: { element: _vm.curComponent },
              }),
              _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini" },
                      on: { click: _vm.closeCustomSort },
                    },
                    [_vm._v(_vm._s(_vm.$t("chart.cancel")) + "\n      ")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "mini" },
                      on: { click: _vm.saveCustomSort },
                    },
                    [_vm._v(_vm._s(_vm.$t("chart.confirm")) + "\n      ")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }